


















import { Component, Prop, Vue } from "vue-property-decorator";
import GuideContainer from "@/components/GuideContainer.vue";

export enum GuidePaths {
  AGENCIES_COMPETITOR_REPORT = "Agencies/CompetitorReport",
  AGENCIES_CUSTOM_REPORT = "Agencies/CustomReport",
  INVESTOR_TOP = "Investor/Top",
  INVESTOR_COMPARATOR = "Investor/Comparator",
  INVESTOR_DAYS_COMPARATOR = "Investor/DaysComparator",
  ALERT_FEED = "Alert/Feed",
}

@Component({
  components: { GuideContainer },
})
export default class PageGuide extends Vue {
  @Prop({ required: true }) readonly guidePath!: GuidePaths;

  open = false;
}
